<div class="modal-content">
  <div class="modal-header">
    <h5 class="modal-title" tmwTranslate="anc.habilitation.title">Gestion des Habilitations</h5>
    <button type="button" class="btn-close" (click)="cancel()"></button>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-2">
          <label for="enService" class="form-label mb-1 small" tmwTranslate="tmw.role.estUtilisateur">Afficher utilisateurs</label>
      </div>
      <div class="col-1">
            <tmw-switch name="isrole" id="field_isrole" [(ngModel)]="isUser"  />
      </div>
      <div class="col-3">
        <label for="code" class="form-label mb-1 small required" tmwTranslate="tmw.role.title">Role</label>
      </div>
      <div class="col-6">
        <tmw-dropdown id="roleId" name="roleId" [query]="{ query: 'ListRole', isrole:(isUser)?0:1 }" [(ngModel)]="habilitationParams.roleId"
                      (ngModelChange)="loadAll()"></tmw-dropdown>
      </div>
    </div>
    @if (elements?.length && habilitationParams.roleId) {
    <tmw-multi-select-edit [list]="elements" id="ressourceAssignment" name="ressourceAssignment" [changeAssignment]="false" keyField="id" labelFiled="libelle"
                           [enableFilter]="true" [isSaving]="isSaving" [(ngModel)]="elementIds" (assigned)="onAssigned($event)"
                           (unassigned)="onUnassigned($event)">
    </tmw-multi-select-edit>
    }
  </div>
</div>